module.exports = __webpack_public_path__ + "static/media/Touch.dd7e13c0.png";